// extracted by mini-css-extract-plugin
module.exports = {"scrollToTop":"main_scrollToTop_2dRyv","isHidden":"main_isHidden_3zS-Y"};